import * as React from 'react';
import { Preloader } from '../../components/Preloader';
import { useSelector } from 'react-redux';
import { selectStatus } from '../../selectors/projects';
import { EBuildersProjectsDataStatus } from '../../types/buildersProjects';

export const PreloaderContainer = () => {
  const status = useSelector(selectStatus);

  if (status !== EBuildersProjectsDataStatus.Fetching) {
    return null;
  }

  return <Preloader />;
};
